import React from 'react';

import { INavBarOptions } from '../types';

const NavBarPropsContext = React.createContext<INavBarOptions | undefined>(undefined);

/**
 * Provider component that provides NavBar props to the component tree
 */
export const NavBarPropsProvider: React.FC<INavBarOptions & { children: React.ReactNode }> = ({
  children,
  ...props
}) => {
  const contextValue: INavBarOptions = {
    ...props
  };

  return <NavBarPropsContext.Provider value={contextValue}>{children}</NavBarPropsContext.Provider>;
};

/**
 * Hook to access all NavBar props
 * @returns INavBarOptions containing all NavBarWithContext props
 * @throws Error if used outside of NavBarPropsProvider
 */
export const useNavBarProps = (): INavBarOptions => {
  const context = React.useContext(NavBarPropsContext);

  if (context === undefined) {
    throw new Error('useNavBarProps must be used within a NavBarPropsProvider');
  }

  return context;
};
